module.exports = __webpack_public_path__ + "static/media/vector.2808ccf3.svg";